export class ActionItemUpdateStatusModel {
    userID: number;
    updateId: number;
    actionId: number;
    statusId: number;
    assignToId: number;
    handleType: number;
    note: string;
    productId = 0;
    previousAssingId = 0;
    previousStatus = 0;
}
